



























import { IDomain } from "@/models/domains";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "domains-form": () =>
      import("@/components/app/admin/domains/domainsForm.vue")
  }
})
export default class DomainsFormModal extends Vue {
  @Prop({ required: false, default: "" })
  public domainId!: IDomain["id"];
  // Data
  public isProcessing = false;
  public isDisabled = true;
}
